module.exports = __webpack_public_path__ + "static/media/DSC_0357.f8946a03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events/DSC_0357.jpg
// module id = 598
// module chunks = 0